import api from './axios';

export const listar    = ()          => api.get('/cores-uniforme/');
export const criar     = (data)      => api.post('/cores-uniforme/', data);
export const atualizar = (id, data)  => api.patch(`/cores-uniforme/${id}`, data);
